export default "__VITE_ASSET__BFuChdF8__"